const config = {
  google: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
    clientSecret: process.env.REACT_APP_GOOGLE_CLIENT_SECRET,
  },
  microsoft: {
    auth: {
      clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
      authority: "https://login.microsoftonline.com/common",
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false,
    },
    codeChallenge: process.env.REACT_APP_MICROSOFT_CODE_CHALLENGE,
  },
  apiUrl: process.env.REACT_APP_API_BASE_URL,
};

export default config;
